export default __webpack_public_path__ + "static/media/twelve.388636d1.svg";